module.exports = __webpack_public_path__ + "static/media/logo.3efdaf1f.png";